import type { Order } from '@brighterly/lib-core-types/orders/interfaces'

import { OrderType, UpsellPlacement } from '@brighterly/lib-core-types/orders/enums'

interface ResolveUpsellPlacementOptions {
  orderId: number
  upsellOrder: Order | null
  flowPlacement: UpsellPlacement
}

interface UpsellPlacementBody {
  upsell_placement?: UpsellPlacement
}

interface ValidationErrorResponse {
  response?: {
    status?: number
    data?: {
      message?: string
      errors?: Record<string, string[]>
    }
  }
}

const UNPROCESSABLE_STATUS = 422
const PLACEMENT_FIELD = 'upsell_placement'

export const resolveUpsellPlacement = ({ orderId, upsellOrder, flowPlacement }: ResolveUpsellPlacementOptions): UpsellPlacement | null => {
  const isLoadedUpsellOrder = upsellOrder?.id === orderId && upsellOrder.type === OrderType.UPSELL
  return isLoadedUpsellOrder ? flowPlacement : null
}

export const buildUpsellPlacementBody = (placement: UpsellPlacement | null | undefined): UpsellPlacementBody => {
  return placement ? { upsell_placement: placement } : {}
}

const getPlacementErrors = (err: unknown): string[] | null => {
  const response = (err as ValidationErrorResponse)?.response
  if (response?.status !== UNPROCESSABLE_STATUS) return null
  return response.data?.errors?.[PLACEMENT_FIELD] || null
}

export const isUpsellOfferUnavailableError = (err: unknown): boolean => !!getPlacementErrors(err)?.length

export const getUpsellOfferUnavailableMessage = (err: unknown): string | null => {
  const errors = getPlacementErrors(err)
  if (!errors?.length) return null
  return (err as ValidationErrorResponse).response?.data?.message || errors[0] || null
}
